import React, { useEffect } from "react";
import {
  FrVrfButton,
  FrVrfFooter,
  FrVrfMultipleLineInputField,
} from "@vrf/fr-vrf-web-components-react";
import { useGlobalNotifier, useMessage } from "@vrf/fr-vrf-core-react";
import { ApplicationMessageScreen } from "../../../messages/screen-message";
import { createModal } from "../../modal";
import { useDesignInfoInputDialogState } from ".";
import { usePageNavigation } from "../../../pages/use-page-navigation";
import { InDefCommonFlagType } from "../../../util/general-code/enums/general-codes";

export const DesignInfoInputDialogContent = () => {
  const { showConfirmationDialog, resetUserError } = useGlobalNotifier();
  const { messageForScreen } = useMessage();
  const [dialogState, setDialogState] = useDesignInfoInputDialogState();
  const { moveToModalPage, closeModalPage } = usePageNavigation();

  const onInitialDisplayed = () => {
    moveToModalPage();
    resetUserError();
    setDialogState((prevState) => ({
      ...prevState,
      isEdited: false,
    }));
  };
  useEffect(onInitialDisplayed, []);

  const valueChangeHandle = (event: CustomEvent) => {
    const inputValue = event.detail.value;
    const isValid = event.detail.isValid;
    setDialogState((prevState) => ({
      ...prevState,
      designInfo: inputValue,
      isEdited: true,
      formValidation: isValid,
    }));
  };

  const onClickCompleteInput = () => {
    const designInfo = dialogState.designInfo;
    const taskList = dialogState.task;
    taskList.stupTasks.dsgnInfo = designInfo;
    closeModalPage();
    setDialogState((prevState) => ({
      ...prevState,
      task: taskList,
      isShow: false,
      isEdited: false,
      formValidation: true,
    }));
  };

  const onClickCancel = () => {
    if (!dialogState.isEdited) {
      closeModalPage();
      setDialogState((prevState) => ({
        ...prevState,
        isShow: false,
        isEdited: false,
        formValidation: true,
      }));
      return;
    }
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
      onOkButtonClicked: () => {
        closeModalPage();
        setDialogState((prevState) => ({
          ...prevState,
          isShow: false,
          isEdited: false,
          formValidation: true,
        }));
      },
    });
  };

  return (
    <>
      {createModal(
        "Input Design Info",
        <div>
          <div>
            <FrVrfMultipleLineInputField
              labelContent="Description"
              placeholder="Please input..."
              content={dialogState.designInfo}
              style={{
                "--vrf-multiple-line-input-field-label-width": "100px",
                "--vrf-multiple-line-input-field-input-height": "400px",
                "--vrf-multiple-line-input-field-input-width": "800px",
              }}
              clearButtonVisible={true}
              onInputValueChanged={valueChangeHandle}
              disabled={dialogState.reqTskSlctdFlg === InDefCommonFlagType.YES}
              constraint="Size(value, {min: 0, max: 12000})"
            />
          </div>
          <FrVrfFooter>
            <FrVrfButton
              content="Cancel"
              theme="secondary"
              size="large"
              onClicked={onClickCancel}
            />
            <FrVrfButton
              content="Complete Input"
              theme="primary"
              size="large"
              onClicked={onClickCompleteInput}
              visible={dialogState.reqTskSlctdFlg === InDefCommonFlagType.NO}
              disabled={!dialogState.isEdited || !dialogState.formValidation}
              authActId="design_info_input_dialog.button.complete_input"
            />
          </FrVrfFooter>
        </div>,
        () => {},
        "medium",
      )}
    </>
  );
};
